import { RateIndexAdditionalOptionsPanel } from "../RateIndexAdditionalOptionsPanel";
import { RateIndexControlMainPanel } from "../RateIndexControlMainPanel";
import { RateIndexRateOptionsPanel } from "../RateIndexRateOptionsPanel";
import { DataSource, Layout } from "@mcleod/components";

export abstract class AutogenLayoutRateIndexControlPanel extends Layout {
    layoutRateIndexAdditionalOptionsPanel: RateIndexAdditionalOptionsPanel;
    layoutRateIndexControlMainPanel: RateIndexControlMainPanel;
    layoutRateOptions: RateIndexRateOptionsPanel;
    sourceRateIndexControl: DataSource;
}
